const OfferBadgeModel = {
  text: { pl: '' },
  colorText: '',
  colorBackground: '',
};

export default OfferBadgeModel;
